const EXPENSES = [
  { merchant: "Delta Airlines", date: "Oct 18", category: "Travel",   amount: "$428.00",   status: "Verified", initials: "DA", color: "#2563EB" },
  { merchant: "Notion",         date: "Oct 17", category: "Software", amount: "$16.00",    status: "Verified", initials: "No", color: "#111111" },
  { merchant: "Whole Foods",    date: "Oct 16", category: "Meals",    amount: "$94.23",    status: "Pending",  initials: "WF", color: "#059669" },
  { merchant: "AWS",            date: "Oct 15", category: "Hosting",  amount: "$1,204.50", status: "Verified", initials: "AW", color: "#F59E0B" },
  { merchant: "Zoom",           date: "Oct 14", category: "Software", amount: "$15.99",    status: "Approved", initials: "Zo", color: "#2563EB" },
  { merchant: "Uber",           date: "Oct 13", category: "Travel",   amount: "$34.50",    status: "Flagged",  initials: "Ub", color: "#111827" },
];

const STATUS_STYLE: Record<string, string> = {
  Verified: "bg-[var(--success-50)] text-[var(--success)]",
  Approved: "bg-[var(--success-50)] text-[var(--success)]",
  Pending:  "bg-[var(--warning-50)] text-[var(--warning)]",
  Flagged:  "bg-[var(--danger-50)]  text-[var(--danger)]",
};

export function InboxPanel() {
  return (
    <div className="flex flex-col h-full bg-white">
      {/* Header */}
      <div className="px-4 py-2.5 border-b border-[var(--ink-200)] shrink-0">
        <div className="flex items-center gap-1.5">
          {["All", "Pending", "Approved", "Flagged"].map((t, i) => (
            <span
              key={t}
              className={[
                "text-[11px] font-semibold px-2.5 py-1 rounded-full",
                i === 0
                  ? "bg-[var(--ink-950)] text-white"
                  : "text-[var(--ink-500)] border border-[var(--ink-200)]",
              ].join(" ")}
            >
              {t}
            </span>
          ))}
          <div className="ml-auto flex items-center gap-1 h-7 px-2.5 rounded-lg border border-[var(--ink-200)] bg-[var(--ink-50)]">
            <svg className="w-3 h-3 text-[var(--ink-400)]" fill="none" viewBox="0 0 16 16" stroke="currentColor" strokeWidth={2}>
              <circle cx="7" cy="7" r="4" /><path d="M11 11l3 3" strokeLinecap="round" />
            </svg>
            <span className="text-[11px] text-[var(--ink-400)]">Search</span>
          </div>
        </div>
      </div>

      {/* Rows — 2-line layout, no separate date/category/action columns */}
      <div className="flex-1 overflow-auto divide-y divide-[var(--ink-100)]">
        {EXPENSES.map((e) => (
          <div key={e.merchant + e.date} className="flex items-center gap-3 px-4 py-2.5">
            <span
              className="w-9 h-9 rounded-full shrink-0 flex items-center justify-center text-[12px] font-bold text-white"
              style={{ backgroundColor: e.color }}
            >
              {e.initials}
            </span>
            <div className="flex-1 min-w-0">
              {/* Line 1: merchant name + amount */}
              <div className="flex items-center justify-between gap-2">
                <span className="text-[13px] font-semibold text-[var(--ink-950)] truncate">{e.merchant}</span>
                <span className="text-[13px] font-semibold text-[var(--ink-950)] shrink-0">{e.amount}</span>
              </div>
              {/* Line 2: category + date + status */}
              <div className="flex items-center justify-between gap-2 mt-0.5">
                <div className="flex items-center gap-1.5">
                  <span className="text-[10px] font-medium border border-[var(--ink-200)] px-1.5 py-0.5 rounded-full text-[var(--ink-500)]">
                    {e.category}
                  </span>
                  <span className="text-[10px] text-[var(--ink-400)]">{e.date}</span>
                </div>
                <span className={["text-[10px] font-semibold px-1.5 py-0.5 rounded-full shrink-0", STATUS_STYLE[e.status]].join(" ")}>
                  {e.status}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Footer */}
      <div className="px-4 py-2.5 border-t border-[var(--ink-200)] shrink-0 flex items-center justify-between">
        <span className="text-[11px] text-[var(--ink-500)]">Showing 6 of 142</span>
        <span className="text-[11px] font-semibold text-[var(--brand-700)]">Export to QuickBooks →</span>
      </div>
    </div>
  );
}
